import { useTranslation } from 'react-i18next';
import { Tabs } from '@/components/ui/tabs';
import { useRoutedTabs } from '@/Pages/routedTabs';
import { RISK_TABS } from '@/Pages/tabRoutes';
import QueueTab from './QueueTab';
import HealthTab from './HealthTab';
import RulesTab from './RulesTab';
import ReviewersTab from './ReviewersTab';

/**
 * §22 / ADR-0017 — fraud, loss prevention and anomaly detection.
 *
 * The Queue tab is gated on `risk.review` alone (a case names a person), and
 * that key alone is enough to also see Health — the split lives in
 * `tabRoutes.ts` and mirrors `RiskEventsController` / `RiskHealthController`
 * exactly. Rules and Reviewers are `risk.configure`, the tenant-admin tier: a
 * threshold is a number and a roster is a delivery list, neither is an
 * allegation.
 */
export default function Risk() {
  const { t } = useTranslation();
  const routed = useRoutedTabs('/risk', RISK_TABS);
  if (!routed.open) return routed.redirect;
  const { tabs, current, select } = routed;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-semibold">{t('risk.title')}</h1>
        <p className="text-sm text-ink-muted">{t('risk.subtitle')}</p>
      </div>

      <Tabs
        tabs={tabs.map((entry) => ({ key: entry.id, label: t(entry.labelKey) }))}
        value={current}
        onChange={select}
        label={t('risk.title')}
        idPrefix="risk"
        className="scrollbar-thin gap-x-5 overflow-x-auto"
      />

      {current === 'queue' && <QueueTab />}
      {current === 'health' && <HealthTab />}
      {current === 'rules' && <RulesTab />}
      {current === 'reviewers' && <ReviewersTab />}
    </div>
  );
}
